import { HttpErrorResponse } from '@angular/common/http';

export function extractHttpErrorMessage(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  const body = error.error;

  if (typeof body === 'string' && body.trim()) {
    return body;
  }

  const content = body?.payload?.content;
  if (content != null && typeof content === 'object') {
    const messages = Object.values(content).flat();
    const firstMessage = messages[0];

    if (messages.length > 0 && typeof firstMessage === 'string') {
      return firstMessage;
    }
  }

  if (typeof body?.message === 'string' && body.message.trim()) {
    return body.message;
  }

  if (typeof body?.error === 'string' && body.error.trim()) {
    return body.error;
  }

  return null;
}
